import React from 'react';
import './FormPage.scss';

export type FormPageVariant = 'default' | 'narrow' | 'bare';

interface FormPageProps {
  /** Заголовок в тёмной шапке (для variant="bare" шапка скрыта) */
  title: string;
  subtitle?: React.ReactNode;
  /** default — широкая карточка, narrow — узкая (вход, пароли), bare — без карточки (для модальных окон) */
  variant?: FormPageVariant;
  children: React.ReactNode;
}

/** Единая оболочка форм сайта: регистрация, профиль, вход, смена пароля и т. д. */
export const FormPage: React.FC<FormPageProps> = ({ title, subtitle, variant = 'default', children }) => (
  <div className={`form-page${variant === 'default' ? '' : ` form-page--${variant}`}`}>
    <header className="form-page__header">
      <h2 className="form-page__title">{title}</h2>
      {subtitle && <p className="form-page__subtitle">{subtitle}</p>}
    </header>
    {children}
  </div>
);

interface FieldProps {
  label: string;
  /** id поля ввода; без него подпись выводится как обычный текст (для групп и даты) */
  htmlFor?: string;
  optional?: boolean;
  hint?: React.ReactNode;
  error?: React.ReactNode;
  children: React.ReactNode;
}

/** Поле формы: подпись, элемент ввода и подсказка / ошибка под ним. */
export const Field: React.FC<FieldProps> = ({ label, htmlFor, optional, hint, error, children }) => (
  <div className="form-page__field">
    {htmlFor ? (
      <label className="form-page__label" htmlFor={htmlFor}>
        {label}
        {optional && <span className="form-page__optional">необязательно</span>}
      </label>
    ) : (
      <span className="form-page__label">
        {label}
        {optional && <span className="form-page__optional">необязательно</span>}
      </span>
    )}
    {children}
    {error ? (
      <span id={htmlFor ? `${htmlFor}-error` : undefined} className="form-page__hint form-page__hint--error" role="alert">
        {error}
      </span>
    ) : hint ? (
      <span className="form-page__hint">{hint}</span>
    ) : null}
  </div>
);
